export default __webpack_public_path__ + "static/media/attach-file.e1fd22e0.svg";